import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl, ipAddress, userName} from "../Univ";
function OwnerDisputes() {
    const userId =
        localStorage.getItem("user_id");
    const [
        ownerId,
        setOwnerId
    ] = useState(null);
    const [
        requirements,
        setRequirements
    ] = useState([]);
    const [
        selectedRequirement,
        setSelectedRequirement
    ] = useState(null);
    const [
        assignments,
        setAssignments
    ] = useState([]);
    const [
        selectedAssignment,
        setSelectedAssignment
    ] = useState(null);
    const [
        disputes,
        setDisputes
    ] = useState([]);
    const [
        formData,
        setFormData
    ] = useState({
        title: "",
        description: ""
    });
    const [showAssignmentModal, setShowAssignmentModal] = useState(false);
    const [showDisputeModal, setShowDisputeModal] = useState(false);
    // ---------------- OWNER ----------------
    useEffect(() => {
        axios.get(
            baseUrl +
            "landowner-profile/" +
            userId +
            "/"
        )
            .then((res) => {
                if (
                    res.data.length > 0
                ) {
                    setOwnerId(
                        res.data[0].id
                    );
                }
            });
    }, [userId]);
    // ---------------- REQUIREMENTS ----------------
    useEffect(() => {
        if (!ownerId) return;
        axios.get(
            baseUrl +
            "landowner-req/" +
            ownerId +
            "/"
        )
            .then((res) => {
                setRequirements(
                    res.data
                );
            });
    }, [ownerId]);
    // ---------------- ASSIGNMENTS ----------------
    const fetchAssignments = async (requirementId) => {
        try {
            const res = await axios.get(
                baseUrl +
                "assignment-requirement/" +
                requirementId +
                "/"
            );
            setAssignments(res.data);
            setShowAssignmentModal(true);
        } catch (err) {
            console.log(err);
        }
    };
    const handleRequirementClick = (
        req
    ) => {
        setSelectedRequirement(
            req
        );
        fetchAssignments(
            req.id
        );
    };
    // ---------------- DISPUTES ----------------
    const fetchDisputes = async (assignmentId) => {
        try {
            const res = await axios.get(
                baseUrl +
                "dispute-assignment/" +
                assignmentId +
                "/"
            );
            setDisputes(res.data);
            setShowDisputeModal(true);
        } catch (err) {
            console.log(err);
        }
    };
    // ---------------- FORM ----------------
    const handleChange = (
        e
    ) => {
        setFormData({
            ...formData,
            [e.target.name]:
            e.target.value
        });
    };
    // ---------------- CREATE DISPUTE ----------------
    const createDispute =
        async (
            e
        ) => {
            e.preventDefault();
            if (
                !selectedAssignment
            ) {
                Swal.fire(
                    "Error",
                    "Select Assignment",
                    "error"
                );
                return;
            }
            try {
                const fd =
                    new FormData();
                fd.append(
                    "assignment",
                    selectedAssignment.id
                );
                fd.append(
                    "raised_by",
                    "OWNER"
                );
                fd.append(
                    "title",
                    formData.title
                );
                fd.append(
                    "description",
                    formData.description
                );
                fd.append(
                    "status",
                    "OPEN"
                );
                fd.append(
                    "addedby",
                    userName
                );
                fd.append(
                    "ip_add",
                    ipAddress
                );
                await axios.post(
                    baseUrl +
                    "dispute/",
                    fd
                );
                Swal.fire(
                    "Success",
                    "Dispute Raised",
                    "success"
                );
                setFormData({
                    title: "",
                    description: ""
                });
                fetchDisputes(
                    selectedAssignment.id
                );
            } catch (err) {
                console.log(
                    err.response?.data
                );
            }
        };
    // ---------------- RESOLVE ----------------
    const resolveDispute =
        async (
            dispute
        ) => {
            const result =
                await Swal.fire({
                    title:
                        "Resolution",
                    input:
                        "textarea",
                    inputLabel:
                        "Enter Resolution",
                    showCancelButton:
                        true
                });
            if (
                !result.value
            ) return;
            try {
                await axios.patch(
                    baseUrl +
                    "update-dispute/" +
                    dispute.id +
                    "/",
                    {
                        status:
                            "RESOLVED",
                        resolution:
                        result.value
                    }
                );
                Swal.fire(
                    "Success",
                    "Resolved",
                    "success"
                );
                fetchDisputes(
                    selectedAssignment.id
                );
            } catch (err) {
                console.log(err);
            }
        };
    return (
        <section className="container mt-4">

            <div className="page-header">

                <h3>
                    Owner Disputes
                </h3>

                <small>
                    Manage Worker Disputes & Resolutions
                </small>

            </div>

            {/* REQUIREMENTS */}

            <div className="row">

                {requirements.length === 0 && (
                    <div className="alert alert-warning">

                        No Requirements Found

                    </div>
                )}

                {requirements.map((req) => (
                    <div
                        key={req.id}
                        className="col-lg-3 col-md-4 col-sm-6 mb-4"
                    >

                        <div
                            className="card app-card"
                            style={{
                                cursor: "pointer"
                            }}
                            onClick={() => {
                                setSelectedRequirement(req);
                                fetchAssignments(req.id);
                            }}
                        >

                            <div className="app-card-header">

                                🌱 {req.crop_type}

                            </div>

                            <div className="app-card-body">

                                <p>

                                    <strong>
                                        Location:
                                    </strong>
                                    {" "}
                                    {req.location}

                                </p>

                                <p>

                                    <strong>
                                        Pincode:
                                    </strong>
                                    {" "}
                                    {req.pincode}

                                </p>

                                <p>

                                    <strong>
                                        Budget:
                                    </strong>
                                    {" "}
                                    ₹{req.budget}

                                </p>

                                <p>

                                    <strong>
                                        Date:
                                    </strong>
                                    {" "}
                                    {req.required_date}

                                </p>

                            </div>

                            <div className="app-card-footer">

                                <button
                                    className="btn btn-action w-100"
                                >
                                    👨‍🌾 View Workers
                                </button>

                            </div>

                        </div>

                    </div>
                ))}

            </div>

            {/* ASSIGNMENTS MODAL */}

            {showAssignmentModal && (
                <div
                    className="modal fade show app-modal"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,.5)"
                    }}
                >

                    <div className="modal-dialog modal-xl modal-dialog-centered">

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">

                                    Workers Assigned For :
                                    {" "}
                                    {selectedRequirement?.crop_type}

                                </h5>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() =>
                                        setShowAssignmentModal(false)
                                    }
                                />

                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto"
                                }}
                            >

                                <div className="row">

                                    {assignments.length === 0 && (
                                        <div className="alert alert-warning">

                                            No Assigned Workers

                                        </div>
                                    )}

                                    {assignments.map((item) => (
                                        <div
                                            key={item.id}
                                            className="col-lg-4 col-md-6 mb-4"
                                        >

                                            <div
                                                className="card app-card"
                                                style={{
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => {
                                                    setSelectedAssignment(item);
                                                    fetchDisputes(item.id);
                                                }}
                                            >

                                                <div className="app-card-header">

                                                    👨‍🌾
                                                    {" "}
                                                    {item.worker?.name}

                                                </div>

                                                <div className="app-card-body">

                                                    <p>

                                                        <strong>
                                                            Mobile:
                                                        </strong>
                                                        {" "}
                                                        {item.worker?.mobile}

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Work Type:
                                                        </strong>
                                                        {" "}
                                                        {item.worker?.work_type}

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Present Days:
                                                        </strong>
                                                        {" "}
                                                        {item.total_present_days}

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Total Amount:
                                                        </strong>
                                                        {" "}
                                                        ₹{item.total_amount}

                                                    </p>

                                                </div>

                                                <div className="app-card-footer">

                                                    <button
                                                        className="btn btn-success-action w-100"
                                                    >

                                                        View Disputes

                                                    </button>

                                                </div>

                                            </div>

                                        </div>
                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            )}

            {/* DISPUTE MODAL */}

            {showDisputeModal && (
                <div
                    className="modal fade show app-modal"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,.5)"
                    }}
                >

                    <div className="modal-dialog modal-xl modal-dialog-centered">

                        <div className="modal-content">

                            <div className="modal-header">

                                <h5 className="modal-title">

                                    Disputes -
                                    {" "}
                                    {selectedAssignment?.worker?.name}

                                </h5>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    onClick={() =>
                                        setShowDisputeModal(false)
                                    }
                                />

                            </div>

                            <div
                                className="modal-body"
                                style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto"
                                }}
                            >

                                {/* CREATE DISPUTE */}

                                <div className="app-modal-highlight mb-4">

                                    <h5 className="mb-3">

                                        🚨 Raise New Dispute

                                    </h5>

                                    <input
                                        type="text"
                                        className="form-control mb-3"
                                        placeholder="Dispute Title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                    />

                                    <textarea
                                        rows="4"
                                        className="form-control mb-3"
                                        placeholder="Dispute Description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                    />

                                    <button
                                        className="btn btn-danger"
                                        onClick={createDispute}
                                    >
                                        Raise Dispute
                                    </button>

                                </div>

                                {/* DISPUTE HISTORY */}

                                <div className="row">

                                    {disputes.length === 0 && (
                                        <div className="alert alert-info">

                                            No Disputes Raised Yet

                                        </div>
                                    )}

                                    {disputes.map((item) => (
                                        <div
                                            key={item.id}
                                            className="col-lg-6 mb-4"
                                        >

                                            <div className="card app-card">

                                                <div className="app-card-header">

                                                    {item.title}

                                                </div>

                                                <div className="app-card-body">

                                                    <p>

                                                        <strong>
                                                            Raised By:
                                                        </strong>
                                                        {" "}
                                                        {item.raised_by}

                                                    </p>

                                                    <p>

                                                        {item.description}

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Status:
                                                        </strong>
                                                        {" "}

                                                        {item.status === "OPEN" ? (
                                                            <span className="badge bg-danger">

                            OPEN

                          </span>
                                                        ) : (
                                                            <span className="badge bg-success">

                            RESOLVED

                          </span>
                                                        )}

                                                    </p>

                                                    <p>

                                                        <strong>
                                                            Resolution:
                                                        </strong>
                                                        {" "}
                                                        {item.resolution || "Pending"}

                                                    </p>

                                                </div>

                                                <div className="app-card-footer">

                                                    {item.status === "OPEN" && (
                                                        <button
                                                            className="btn btn-success-action w-100"
                                                            onClick={() =>
                                                                resolveDispute(item)
                                                            }
                                                        >
                                                            Resolve Dispute
                                                        </button>
                                                    )}

                                                </div>

                                            </div>

                                        </div>
                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </section>
    );
}
export default OwnerDisputes;